enum NavigationTypeEnum {
  Basic,
  LoggedIn
}

export default NavigationTypeEnum;
